import React from "react";
import Index from "../../container/Index";
import { toast } from "react-toastify";
import { sendWhatsappDocumentApiHandler } from "../../services/AdminIndex";

// Modules that can send WhatsApp - one toggle each in Company Setup
// (access.utility.whatsappModules). Keys match the backend
// WHATSAPP_MODULE_KEYS (utils/CompanyWhatsappSettings.js); for documents
// the key is the docType.
export const WHATSAPP_MODULES = [
  { key: "SalesEntry", title: "Sales Entry" },
  { key: "OtherSalesEntry", title: "Other Sales Entry" },
  { key: "SalesOrder", title: "Sales Order" },
  { key: "SalesReturn", title: "Sales Return" },
  { key: "SalesVoucher", title: "Sales Voucher Entry" },
  { key: "PackingSlip", title: "Packing Slip" },
  { key: "PurchaseOrder", title: "Purchase Order" },
  { key: "PurchaseReturn", title: "Purchase Return" },
  { key: "CreditNote", title: "Credit Note" },
  { key: "DebitNote", title: "Debit Note" },
  { key: "DebitNoteSales", title: "Debit Note Sales" },
  { key: "LedgerReport", title: "Ledger Report" },
  { key: "OutstandingReport", title: "Outstanding Report" },
  { key: "AutoReport", title: "Auto Report Mail" },
];

// No module list saved yet (company set up before the per-module
// toggles) = every module on, as it was.
export const isWhatsappModuleOn = (utility, moduleKey) => {
  const modules = utility?.whatsappModules;
  if (!moduleKey || !modules || typeof modules !== "object") return true;
  return !!modules[moduleKey];
};

// Every WhatsApp option on the company side shows only when the Super
// Admin has turned WhatsApp Integration on for the company (Company
// Setup) and, with moduleKey, that module's toggle too. Not loaded yet
// counts as off.
export const isWhatsappEnabled = (companySetup, moduleKey) =>
  !!companySetup?.utility?.whatsappIntegration &&
  isWhatsappModuleOn(companySetup?.utility, moduleKey);

// List-row WhatsApp icon: sends the document's print PDF to its party.
export default function WhatsappSendButton({ docType, id }) {
  const dispatch = Index.useDispatch();
  const { token, companySetup } = Index.useSelector((state) => state.ERPAdminReducer);

  if (!isWhatsappEnabled(companySetup, docType)) return null;

  const handleSend = () => {
    dispatch({ type: "LOADER_START" });
    sendWhatsappDocumentApiHandler(token, docType, id).then((response) => {
      if (response.status === 201 || response.status === 200) {
        toast.success(response.message);
        dispatch({ type: "LOADER_END" });
      } else {
        dispatch({ type: "ADMIN_ERROR_HANDLER", payload: response });
      }
    });
  };

  return (
    <Index.Tooltip title="Whatsapp" placement="bottom" arrow>
      <Index.Link className="table-btns table-edit-btn" disableRipple onClick={handleSend}>
        <img src={Index.Png.WhatsApp} className="table-icons" alt="" />
      </Index.Link>
    </Index.Tooltip>
  );
}
